import { schema } from 'normalizr';

import { LocationTypeModel } from 'models';

export const locationTypeEntity = new schema.Entity<LocationTypeModel>(
  'locationTypes',
);
